module.exports = __webpack_public_path__ + "static/img/service_facial.6ad0b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service_facial.jpg
// module id = 178
// module chunks = 1